import { observable }       from 'rewire-core';
import timecardModeModel    from './TimecardModeModel';
import timecardModel        from './TimecardModel';
import summaryListModel     from './SummaryListModel';

export class TimecardPageModel {
  constructor() {
  }

  reset() {
    if (timecardModeModel.isMode('Timecard')) {
      timecardModel.reset();
      summaryListModel.reset();
    }
  }
}

const timecardPageModel = observable(new TimecardPageModel());
export default timecardPageModel;
